module.exports = __webpack_public_path__ + "img/AFG.796d44e5.gif";